import { render, staticRenderFns } from "./ClientsRankingCard.vue?vue&type=template&id=dd0d3632&scoped=true"
import script from "./ClientsRankingCard.vue?vue&type=script&lang=js"
export * from "./ClientsRankingCard.vue?vue&type=script&lang=js"
import style0 from "./ClientsRankingCard.vue?vue&type=style&index=0&id=dd0d3632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0d3632",
  null
  
)

export default component.exports